<template>
  <WorkBasicDialog ref="uncaughtErrorDialog">
    <template #header>
      {{ $t('Components.sentences.unexpectedError') }}
    </template>

    <template #content-wrapper>
      <div class='axios-error-content-wrapper'>
        <span><b>{{ $t('Common.status') }}:</b> {{ status }}</span>
        <span><b>{{ $t('Common.sub') }}:</b> {{ url }}</span>
        <v-expansion-panels
          class='further-information-panel'
          flat
          accordion
        >
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon='$wArrowDown'>
              <b>{{ $t('Common.details') }}:</b>
            </v-expansion-panel-header>
            <v-expansion-panel-content class='details-wrapper'>
              {{ details }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </template>

    <template #dialog-actions='{ close }'>
      <w-btn
        outlined
        @click='copyToClipboard'
      >
        {{ $t('Components.sentences.copyErrorMessage') }}
      </w-btn>
      <w-btn
        outlined
        @click='close'
      >
        {{ $t('Common.close') }}
      </w-btn>
    </template>
  </WorkBasicDialog>
</template>

<script>
import WorkBasicDialog from '@/components/base_components/dialog/WorkBasicDialog';

export default {
  name: 'UncaughtAxiosErrorDialog',
  components: { WorkBasicDialog },
  data() {
    return { axiosError: null };
  },
  computed: {
    status() {
      return `${this.axiosError.status} ${this.axiosError.statusText}`
    },
    url() {
      return this.axiosError.request.responseURL;
    },
    details() {
      let text =
        this.axiosError.data.message == undefined
          ? this.axiosError.status === 403 
            ? `${this.$t('Components.sentences.noPermission')}.`
            : `${this.$t('Components.sentences.anUnexpectedErrorOccured')}.`
          : this.axiosError.data.message;
      let stackTrace =
        this.axiosError.data.stackTrace == undefined
          ? ''
          : this.axiosError.data.stackTrace;
      return `${text}\n${stackTrace}`;
    }
  },
  methods: {
    open(axiosError) {
      this.axiosError = axiosError;
      window.console.error(axiosError)

      return this.$refs.uncaughtErrorDialog.open();
    },
    async copyToClipboard() {
      // navigator.clipboard braucht eine sichere Verbindung
      try {
        await navigator.clipboard.writeText(`${this.status}\n${this.url}\n${this.details}`).then(() => {});
      }
      catch (e) {
        window.console.warn("Copy to clipboard failed.", e);
        prompt("Copy to clipboard: Ctrl+C, Enter", `${this.status}\n${this.url}\n${this.details}`);
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.axios-error-content-wrapper {
  display: flex;
  flex-direction: column;
  color: var(--v-error-base);
  word-break: break-word;

  .further-information-panel ::v-deep {

    .v-expansion-panel-header, .v-expansion-panel-content__wrap {
      font-size: 1rem;
      color: var(--v-error-base) !important;
      padding: 0 !important;
    }

    .v-expansion-panel-content__wrap {
      word-break: break-word;
      max-height: 20vh;
      overflow-y: scroll;
    }
  }
}
</style>
